exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.topArea[data-v-8876cbd4] {\n  border-bottom: 1px solid #DBDFE2;\n}\n.topArea .locked[data-v-8876cbd4] {\n    opacity: 0.5;\n}\n.topArea .locked *[data-v-8876cbd4] {\n      cursor: default;\n}\n.topArea .btnFilter[data-v-8876cbd4] {\n    background: none;\n}\n.topArea .btnFilter i[data-v-8876cbd4] {\n      color: #00a9f0;\n}\n.topArea .btnFilter.active[data-v-8876cbd4] {\n    border-radius: 100px;\n    background-color: #00a9f0;\n    color: #fff !important;\n    font-weight: 400;\n}\n.topArea .btnFilter.active i[data-v-8876cbd4] {\n      color: #fff !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-8876cbd4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/FeedTop.vue
// module id = 2397
// module chunks = 0